module.exports = __webpack_public_path__ + "img/18.fac01044.png";